"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  CRITICAL: 'Critical',
  SUCCESS: 'Success',
  WARNING: 'Warning',
  INFO: 'Info',
  HIGHLIGHT: 'Highlight',
  NEUTRAL: 'Neutral',
  INTERNAL: 'Internal',
  PASSIVE: 'Passive',
  PREMIUM: 'Premium'
};
exports.default = _default;